import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

const NextLiveEventSectionSkeleton = ({ showEventsList = true }) => (
  <div className="py-5" style={{ backgroundColor: '#4A148C' }}>
    <Row className="justify-content-center mb-4">
      <Col xs={12} lg={8} className="text-center">
        <div className="mb-4">
          <Skeleton width={400} height={80} />
        </div>

        <div className="mb-4">
          <Skeleton width={300} height={60} />
        </div>

        {showEventsList && (
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <Skeleton count={1} width="80%" style={{ marginBottom: '1rem' }} />
            <Skeleton count={5} width="60%" style={{ marginBottom: '0.5rem' }} />
          </div>
        )}
      </Col>
    </Row>

    <Row className="justify-content-center">
      <Col xs={12} lg={8}>
        <h2 className="text-white mb-4">
          <Skeleton width={120} />
        </h2>

        <Card>
          <Skeleton height={300} />

          <CardBody className="p-4">
            <Skeleton width="80%" height={30} style={{ marginBottom: '1rem' }} />
            <Skeleton width="60%" height={20} style={{ marginBottom: '1rem' }} />
            <Skeleton width="90%" height={25} style={{ marginBottom: '1rem' }} />
            <Skeleton count={3} style={{ marginBottom: '1rem' }} />
            <Skeleton height={50} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

export default NextLiveEventSectionSkeleton;
